export default __webpack_public_path__ + "static/media/ko.b6392a9e.svg";